import { render, staticRenderFns } from "./GameOverView.vue?vue&type=template&id=55f106a4&scoped=true"
import script from "./GameOverView.vue?vue&type=script&lang=js"
export * from "./GameOverView.vue?vue&type=script&lang=js"
import style0 from "./GameOverView.vue?vue&type=style&index=0&id=55f106a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f106a4",
  null
  
)

export default component.exports